//## 20. src/components/dashboard/QueueOverview.tsx

import React from 'react';
import { Inbox, Send, TrendingUp, AlertCircle } from 'lucide-react';
import { QueueStats } from '../../types';

interface QueueOverviewProps {
  stats: QueueStats | null;
}

const QueueOverview: React.FC<QueueOverviewProps> = ({ stats }) => {
  const totalQueued = stats?.queueDepth 
    ? Object.values(stats.queueDepth).reduce((a, b) => a + b, 0)
    : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Queue Depth</p>
            <p className="text-2xl font-bold text-gray-900">{totalQueued}</p>
          </div>
          <div className="text-blue-500">
            <Inbox size={24} />
          </div>
        </div>
      </div>
      
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Currently Sending</p>
            <p className="text-2xl font-bold text-gray-900">{stats?.sending || 0}</p>
          </div>
          <div className="text-green-500">
            <Send size={24} />
          </div>
        </div>
      </div>
      
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Send Rate</p>
            <p className="text-2xl font-bold text-gray-900">
              {stats?.sendRate?.currentPerMinute || 0}
              <span className="text-sm text-gray-600 font-normal">/min</span>
            </p>
          </div>
          <div className="text-orange-500">
            <TrendingUp size={24} />
          </div>
        </div>
      </div>
      
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Critical Emails</p>
            <p className="text-2xl font-bold text-gray-900">
              {stats?.queueDepth?.critical || 0}
            </p>
          </div>
          <div className="text-red-500">
            <AlertCircle size={24} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QueueOverview;